






































































































































































































































import {
  createComponent,
  inject,
  onMounted,
  onUnmounted,
  computed,
  ref
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import FormHeader from '../../molecules/FormHeader.vue'
import CompanyErrorDialog from '../../../views/CompanyInformation/CompanyErrorDialog.vue'
import DialogConfirmCreate from './DialogConfirmCreate.vue';
import router from '../../../router'
import customValidator from "@/lib/customValidator.ts"

export default createComponent({
  setup(props, context) {
    let isOpen = true;
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }

    const companyCreateForm = ref(null)
    const companyInfor = computed(() => company.companyInformation);
    
    const companyInforList = computed(() => company.companyInformation.companyInforList);

    let compareTelephoneNumber = computed(() => company.companyInformation.compareTelephoneNumber) as any;

    const updateCompanyInfor = async() => {
      isOpen = false;
      //@ts-ignore
      if(!companyCreateForm.value.validate()) {
        return;
      }
      displayui.openDialogConfirmCreateCompany()
    }

    const redirectToRegister = () =>{
      if(isOpen){
        router.push('/company_detail/register')
      }
    }

    const clearCompanyName = company.clearCompanyName
    onUnmounted(() => {
      company.clearCompanyInfor()
    })

    const regist_token = context.root.$route.query.regist_token
    onMounted(async () => {
      company.getIndustryCode()
      const decrypt = await company.decryptMail(regist_token) as any;
      if(decrypt.data){
        await displayui.openDialogCompanyError();
       }
    })
    const industryListCode = computed(() => company.companyInformation.industryListCode)
    
    const searchPostalCode = async(postal1: any, postal2: any) => {
      isOpen = false;
      const address = await company.searchPostalCode(postal1, postal2) as any;
       if(address.data){
        await displayui.openDialogCompanyError();
       }
    }
    return {
      companyInfor,
      companyInforList,
      updateCompanyInfor,
      clearCompanyName,
      DialogConfirmCreate,
      industryListCode,
      searchPostalCode,
      redirectToRegister,
      companyCreateForm,
      customValidator
    };
  },
  components: {
    FormHeader,
    CompanyErrorDialog,
    DialogConfirmCreate
  },
})
